import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ticketsQueryKey } from '../queries/useTickets'
import { TicketDetail, TicketStatus } from '../types'

export function useChangeTicketStatus() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function changeStatus({
    ticketId,
    status
  }: {
    ticketId: string
    status: TicketStatus
  }) {
    const res = await apiClient.post<TicketDetail>(
      `${SNA_PREFIX}tickets/${ticketId}/change-status/`,
      { status }
    )
    return res.data
  }

  return useMutation({
    mutationFn: changeStatus,
    onSuccess: () => {
      toast.success({ message: t('statusChanged') })
      queryClient.invalidateQueries({ queryKey: ticketsQueryKey })
    },
    onError
  })
}
